import Footer from './Components/Footer';
import Header from './Components/Header';
import Home from './pages/Home';
import './styles/global.css';

function App() {
  return (
    <div className="app">
      <Header />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
